export enum E_NOTIFICATION_TYPE {
  KHATTABAT_CONVERSATION_MESSAGE = "khattabat_conversation_message",
  KHATTABAT_CONVERSATION_MESSAGE_READ = "khattabat_conversation_message_read",
  KHATTABAT_NEW_CLIENT_TO_BE_ASSIGNED = "khattabat_new_client_to_be_assigned"
}
